/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoTracePoint
 */
export interface OutputGeoTracePoint {
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTracePoint
     */
    displayName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTracePoint
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTracePoint
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTracePoint
     */
    placeId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTracePoint
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTracePoint
     */
    text?: string;
}

/**
 * Check if a given object implements the OutputGeoTracePoint interface.
 */
export function instanceOfOutputGeoTracePoint(value: object): boolean {
    return true;
}

export function OutputGeoTracePointFromJSON(json: any): OutputGeoTracePoint {
    return OutputGeoTracePointFromJSONTyped(json, false);
}

export function OutputGeoTracePointFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTracePoint {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
        'score': json['score'] == null ? undefined : json['score'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function OutputGeoTracePointToJSON(value?: OutputGeoTracePoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'displayName': value['displayName'],
        'lat': value['lat'],
        'lon': value['lon'],
        'placeId': value['placeId'],
        'score': value['score'],
        'text': value['text'],
    };
}

